import React, { useCallback, useContext } from 'react';
import { IconMoonStars, IconSun } from '@tabler/icons';

import { useUser } from 'src/queries/user';
import { Spinner, Button, Avatar } from 'src/UIComponents';
import { DarkmodeContext } from 'src/contexts/dark-mode';

function UserProfile({ ...rest }) {
  const { isDarkmode, toggle } = useContext(DarkmodeContext);
  const { isLoading: loadingUser, data: user } = useUser('me');

  const handleLogout = useCallback(() => {
    window.location.assign('/auth/logout');
  }, []);

  if (loadingUser) {
    return <Spinner />;
  }

  return (
    <div {...rest}>
      <div
        style={{
          textAlign: 'center',
        }}
      >
        <Avatar
          src={user?.avatarUrl}
          alt="Profile"
          size="120px"
          className="mt-3"
        />
        <h3>
          {user?.firstName} {user?.lastName}
        </h3>
      </div>

      <div
        style={{
          textAlign: 'center',
        }}
      >
        <Button
          style={{
            display: 'inline-block',
          }}
          outline
          $size="small"
          $color="danger"
          onClick={handleLogout}
        >
          Logga ut
        </Button>
      </div>

      <h4>Settings</h4>
      <Button onClick={toggle}>
        {isDarkmode ? <IconMoonStars /> : <IconSun />}&nbsp;&nbsp;Turn{' '}
        {isDarkmode ? 'off' : 'on'} darkmode
      </Button>
    </div>
  );
}

export default UserProfile;
